import React from 'react';
import './App.css';
import Fundo from './back.jpg';
import Abas from './components/Abas';
import AbasWithTab from './components/AbasWithTab'
import AbasWithTabEN from './components/AbasWithTabEN'
import Console from './components/Console';

import AudioButton from './buttonclick.wav';
import AudioButtonReleased from './buttonclickrelease.wav';
import Splash from './components/Splash';

const audio = new Audio(AudioButton);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: 0,
      aceito: 0,
      mount: false,
      linksPT: [
        {
          "title": "Console",
          "open": false
        },
        {
          "title": "Sobre mim",
          "open": false
        },
        {
          "title": "Change language",
          "open": false
        }
      ],
      linksEN: [
        {
          "title": "Console",
          "open": false
        },
        {
          "title": "About me",
          "open": false
        },
        {
          "title": "Mudar de idioma",
          "open": false
        }
      ]
    }
  }
  audioPlay(){
    const audioEl = document.getElementsByClassName("audio-element-re")[0]
    audioEl.play()
  }
  audioPlayRelease(){
    const audioEl = document.getElementsByClassName("audio-element")[0]
    audioEl.play()
  }
  controlAbas(id){
    if(id !== this.state.linksPT.length - 1){
     this.audioPlayRelease()
     let items = [...this.state.linksPT];
     items[id].open = !this.state.linksPT[id].open;
     this.setState({linksPT: items});
     let itemsEN = [...this.state.linksEN];
     itemsEN[id].open = !this.state.linksEN[id].open;
     this.setState({linksEN: itemsEN});
     this.forceUpdate();
    } else{
        this.audioPlayRelease()
        if(this.state.language == 0){
            this.setState({language: 1});
        } else{
            this.setState({language: 0});
        }
    }
  }
  componentDidMount(){
    
  }
  render(){
    return <div>
      { !this.state.mount && <Splash/> }
      <div className="back">
        <div className="transparent"/>
        <img src={Fundo}/>
      </div>
      <div className="leftBar">
        { this.state.language == 0 && this.state.linksPT.map((item, index) => (
           <div onMouseDown={() => { this.audioPlay() }}
            class={index == 1 || index == 3 ? 'bottomLink': ''}
            onMouseUp={() => { this.controlAbas(index) }}>
            <Link
            key={index}
            language={this.state.language} title={item.title}/>
            </div>
        ))}
        { this.state.language == 1 && this.state.linksEN.map((item, index) => (
            <div onMouseUp={() => { this.controlAbas(index) }}
            onMouseDown={() => { this.audioPlay() }}
            class={index == 1 || index == 3 ? 'bottomLink': ''}>
            <Link
            key={index}
            language={this.state.language} title={item.title}/>
            </div>
        ))}
      </div>
      { this.state.language == 0 && this.state.linksPT[0].open &&
      <Abas
      title={this.state.linksPT[0].title}
      data={Console}
      />
      }
      { this.state.language == 0 && this.state.linksPT[1].open &&
      <AbasWithTab
      title={this.state.linksPT[1].title}
      />
      }
    {
        this.state.language == 1 && this.state.linksPT[1].open &&
        <AbasWithTabEN
        title={this.state.linksEN[1].title}/>
    }
       <audio className="audio-element">
          <source src={AudioButton}></source>
        </audio>
        <audio className="audio-element-re">
          <source src={AudioButtonReleased}></source>
        </audio>
    </div>
  };
}

class Link extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
    render() {
      return <div className="link">
           <li> {this.props.title} </li>
      </div>
    };
}

export default App;